/**
 * Dépendances du lot L52 : contrat et protocole de synchronisation, par chemin relatif tant que `@lakou/*` n'est pas
 * déclaré dans `apps/web/package.json` (RFC-050, fichier propriété de O1). Seul ce fichier change à ce moment-là.
 */
import type { TaskSchema } from '../../../../../packages/contracts/src/entities/dossier.js';
import type { PersonStaffViewSchema } from '../../../../../packages/contracts/src/entities/genealogie.js';
import type { ConsentRecordSchema } from '../../../../../packages/contracts/src/entities/confidentialite.js';
import type { TemplateSchema } from '../../../../../packages/contracts/src/entities/messagerie.js';

import { audienceDe, politiqueDe } from '../../../../../packages/sync/src/serveur/politique.js';

export type Tache = (typeof TaskSchema)['_output'];
export type PersonneEquipe = (typeof PersonStaffViewSchema)['_output'];
export type ConsentementAEnregistrer = (typeof ConsentRecordSchema)['_output'];
export type Modele = (typeof TemplateSchema)['_output'];

// Imports ciblés : l'index de @lakou/sync tire aussi le téléversement, dont le typage `BufferSource` ne passe pas avec
// la bibliothèque DOM du paquet web. Le journal et le rejeu suffisent à L52.
export { creerJournal } from '../../../../../packages/sync/src/client/journal.js';
export { rejouer } from '../../../../../packages/sync/src/client/envoi.js';
export type { ConflitLocal, Journal } from '../../../../../packages/sync/src/client/journal.js';
export type { BilanRejeu, TransportPush } from '../../../../../packages/sync/src/client/envoi.js';

/**
 * Vrai si le serveur de synchronisation connaît ce type d'entité ET que l'équipe peut l'écrire : c'est exactement ce que
 * vérifie `appliquerPush` avant d'accepter une mutation. Lu dans les données versionnées de @lakou/sync, jamais recopié
 * ici : quand le serveur déclarera `consentement` et `compte_rendu` (RFC-L52-001 point 2), M02 les enverra sans changement.
 */
export const entiteSynchronisee = (entityType: string): boolean =>
  politiqueDe(entityType) !== null && audienceDe('equipe').ecriture.includes(entityType);
export type { StockageLocal } from '../../../../../packages/sync/src/types.js';
